import React from "react";
import PropTypes from "prop-types";

import styled, { css } from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

function CaseFilterReset({ activeNavItem, activeNavItemName, searchInput, handleClearSearch, handleShowAll }) {
  const formatNavItemName = (navItem, name) => {
    if (navItem === "all_cases") {
      return "active cases";
    } else if (navItem === "pre_memo") {
      return name + " cases";
    }
    return name;
  };

  return (
    <li>
      <EmptyStatePanel>
        {searchInput && (
          <>
            <h2>
              No search results found for <strong>{searchInput}</strong>
            </h2>
            <EmptyStateButton onClick={handleClearSearch}>clear search</EmptyStateButton>
          </>
        )}

        {!searchInput && activeNavItem && (
          <>
            <h2>
              No <strong>{formatNavItemName(activeNavItem, activeNavItemName)}</strong> found
            </h2>

            {activeNavItem && activeNavItem !== "all_cases" && (
              <EmptyStateButton onClick={handleShowAll}>Show all active cases</EmptyStateButton>
            )}
          </>
        )}
      </EmptyStatePanel>
    </li>
  );
}

CaseFilterReset.propTypes = {
  selectedNavItem: PropTypes.string,
  tagGroup: PropTypes.string,
  caseType: PropTypes.string,
  searchInput: PropTypes.string,
};

export default CaseFilterReset;

// Shared with the Referrals tab's empty states (ReferralsEmptyState.js) so the two lists match.
export const EmptyStatePanel = styled.div`
  width: 100%;
  max-width: 60rem;

  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: column;

  margin-bottom: 1.5rem;
  ${mediaQueries.lg} {
    margin-left: auto;
    margin-right: auto;
  }
  padding: 4rem;

  border-radius: 8px;
  background-image: linear-gradient(to left bottom, #dfdbff, #e7e4ff, #efedff, #f7f6ff, #ffffff);

  h2 {
    font-size: 26px;
    font-weight: 500;
    line-height: 1.1;
  }

  strong {
    color: var(--juno-color-purple);
  }
`;

export const emptyStateAction = css`
  display: inline-block;
  min-height: 56px;

  background-color: var(--juno-color-purple);
  color: var(--juno-color-white);
  text-align: center;

  border: 0;
  border-radius: 12px;
  flex: none;

  margin-top: 1rem;
  padding: 16px 28px;

  font-size: 1rem;
  font-weight: var(--juno-font-weight-regular);
  line-height: 1.5;

  transition:
    background 0.25s,
    color 0.25s;
  &:hover {
    cursor: pointer;
    color: var(--juno-color-purple);
    background-color: var(--juno-color-pale-purple);
  }
`;

export const EmptyStateButton = styled.button`
  ${emptyStateAction}
`;
